import { render, staticRenderFns } from "./triggersCard.vue?vue&type=template&id=4edd8818&scoped=true"
import script from "./triggersCard.vue?vue&type=script&lang=js"
export * from "./triggersCard.vue?vue&type=script&lang=js"
import style0 from "./triggersCard.vue?vue&type=style&index=0&id=4edd8818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edd8818",
  null
  
)

export default component.exports